var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#179C5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3787 41.325C53.8554 41.325 54.2404 41.49 54.5337 41.82C54.827 42.1133 54.9737 42.4983 54.9737 42.975C54.9737 43.3783 54.827 43.745 54.5337 44.075C54.2404 44.3683 53.8554 44.515 53.3787 44.515H43.7537V54.58C43.7537 55.0933 43.5887 55.5333 43.2587 55.9C42.9287 56.23 42.507 56.395 41.9937 56.395C41.517 56.395 41.0954 56.23 40.7287 55.9C40.3987 55.5333 40.2337 55.1117 40.2337 54.635V44.515H30.6637C30.187 44.515 29.802 44.3683 29.5087 44.075C29.2154 43.745 29.0687 43.3417 29.0687 42.865C29.0687 42.425 29.2154 42.0583 29.5087 41.765C29.802 41.4717 30.187 41.325 30.6637 41.325H40.2337V31.315C40.2337 30.8017 40.3987 30.38 40.7287 30.05C41.0587 29.72 41.4804 29.555 41.9937 29.555C42.5437 29.555 42.9654 29.72 43.2587 30.05C43.5887 30.3433 43.7537 30.7467 43.7537 31.26V41.325H53.3787Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.0d90f15a.svg";
export { ForwardRef as ReactComponent };